var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgJob = function SvgJob(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 28,
    viewBox: "0 0 19 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M1.26465 3.76369V20.2365C1.26465 20.7826 1.48159 21.3063 1.86774 21.6925C2.2539 22.0786 2.77764 22.2956 3.32375 22.2956H15.6783C16.2244 22.2956 16.7482 22.0786 17.1343 21.6925C17.5205 21.3063 17.7374 20.7826 17.7374 20.2365V8.23399C17.7374 7.95968 17.6826 7.68813 17.5761 7.43531C17.4697 7.18249 17.3138 6.95348 17.1176 6.76173L12.5464 2.29143C12.1618 1.91529 11.6451 1.70466 11.1071 1.70459H3.32375C2.77764 1.70459 2.2539 1.92153 1.86774 2.30769C1.48159 2.69384 1.26465 3.21758 1.26465 3.76369V3.76369Z",
    stroke: "currentColor",
    strokeWidth: 1.55556,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M6.41211 13.0298H12.5894",
    stroke: "currentColor",
    strokeWidth: 1.55556,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M6.41211 17.1479H9.50076",
    stroke: "currentColor",
    strokeWidth: 1.55556,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M11.5605 1.70459V5.82279C11.5605 6.36889 11.7775 6.89263 12.1636 7.27879C12.5498 7.66494 13.0735 7.88188 13.6196 7.88188H17.7378",
    stroke: "currentColor",
    strokeWidth: 1.55556,
    strokeLinejoin: "round"
  })));
};
export default SvgJob;